import { Directive } from '@angular/core';

@Directive({
  selector: '[uiTimelineMarker]',
  standalone: true
})
export class TimelineMarkerDirective {}
